import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthProvider'
import Navbar from './components/Navbar'
import Landing from './pages/Landing'
import SignIn from './pages/SignIn'
import SignUp from './pages/SignUp'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import VerifyEmail from './pages/VerifyEmail'
import Dashboard from './pages/Dashboard'
import PersonaSetup from './pages/PersonaSetup'
import PublicPersona from './pages/PublicPersona'
import SignOut from './pages/SignOut'
import PlanSelection from './components/PlanSelection'
import { Loader2 } from 'lucide-react'

function PlanPage() {
  const navigate = useNavigate()
  const { refreshMe } = useAuth()
  return <PlanSelection
    onSelected={async () => { await refreshMe(); navigate('/dashboard', { replace: true }) }}
    onCancel={() => navigate(-1)}
  />
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()
  if (loading) return <div className="flex justify-center py-24"><Loader2 size={32} className="animate-spin text-brand-600" /></div>
  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />
  }
  return <>{children}</>
}

function AppLayout() {
  const showNavbar = !window.location.pathname.startsWith('/p/')
  return (
    <div className="min-h-screen flex flex-col">
      {showNavbar && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/plan" element={<ProtectedRoute><PlanPage /></ProtectedRoute>} />
          <Route path="/persona/setup" element={<ProtectedRoute><PersonaSetup /></ProtectedRoute>} />
          <Route path="/p/:handle" element={<PublicPersona />} />
          <Route path="/signout" element={<SignOut />} />
        </Routes>
      </main>
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppLayout />
      </AuthProvider>
    </BrowserRouter>
  )
}
